import axiosInstance from "../axiosInstance";

const Get = async (path) => {
  try {
    const result = await axiosInstance.get(path);
    return result.data;
  } catch (err) {
    throw err;
  }
};

export default Get;
